import { defineMessages } from 'react-intl';


const sidePanelMessages = defineMessages({
    closeButton: {
        id: 'close-button',
        defaultMessage: 'Close',
    },
    okButton: {
        id: 'ok-button-message',
        defaultMessage: 'Ok',
    },
    cancelButton: {
        id: 'cancel-button',
        defaultMessage: 'Cancel',
    },
    saveButton: {
        id: 'save-button-message',
        defaultMessage: 'Save',
    },
    permitDocument: {
        id: 'permit-document-title',
        defaultMessage: 'Permit document',
    },
    reorderContent: {
        id: 'reorder-content-title',
        defaultMessage: 'Reorder content',
    },
    addContent: {
        id: 'add-content-title',
        defaultMessage: 'Add content',
    },
    addAsset: {
        id: 'add-asset-action',
        defaultMessage: 'Add Asset',
    },
});

export default sidePanelMessages;
